export default {
    partnumber_tab_label: "Número de pieza",
    partnumber_tab_device_model: "Modelo de dispositivo",
    partnumber_tab_network: "Red",
    partnumber_tab_created_at: "Creado en",
    partnumber_tab_created_by: "Creado por",
    partnumber_tab_add_new: "Agregar Nuevo",
}